var WebFont = require('webfontloader');

WebFont.load({
	google: {
		families: ['Fira+Sans:400,400i,600,600i,700,700i', 'Open+Sans:400,700i,800i', 'PT+Serif', 'Roboto+Condensed:300,400', 'Roboto+Slab']
	}
});